<!--  -->
<template>
  <div class='nav-title'>
    <div class="quit">
      <slot name="left">
        <img class="quit-img" src="~@/assets/image/quit.png" alt="" @click="handleQuit">
      </slot>
    </div>
    <span>
      {{title}}
    </span>
    <div class="nav-title-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  components: {},
  props: ['title'],
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  methods: {
    handleQuit () {
      let previousRoute = window.localStorage.getItem('previousRoute')
      if (previousRoute) {
        this.$router.back()
      } else {
        this.$router.replace('/')
      }
    }
  }
}

</script>

<style lang='less' scoped>
.nav-title {
  width: 100%;
  height: 48px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  > span {
    font-size: 16px;
  }
  > .quit {
    position: absolute;
    top: 50%;
    left: 20px;
    transform: translate(0, -50%);
    .quit-img {
      width: 28px;
    }
  }
  > .nav-title-right {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(0, -50%);
  }
}
</style>
